import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createProjectKeysSyncActions } from './project-keys.actions'
import { projectKeysInitialState } from './project-keys.slice'
import type { ProjectKeysStore } from './project-keys.type'

export const useProjectKeysStore = create<ProjectKeysStore>()(
  devtools(
    immer((set) => ({
      ...projectKeysInitialState,
      ...createProjectKeysSyncActions(set),
    })),
    {
      name: StoreDevtoolsName.ProjectKeys,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
